const MarketingIndex = () => 
  import(/* webpackChunkName: 'MarketingIndex' */ '@/Marketing/Index');
const BreakthroughIndex = () => 
  import(/* webpackChunkName: 'BreakthroughIndex' */ '@/Marketing/Breakthrough');
const SettingsFacebookIndex = () => 
  import(/* webpackChunkName: 'SettingsFacebookIndex' */ '@/Marketing/SettingsFacebook');
const GetStartedIndex = () => 
  import(/* webpackChunkName: 'GetStartedIndex' */ '@/Marketing/GetStarted');
const AdvertiseType = () => 
  import(/* webpackChunkName: 'AdvertiseType' */ '@/Marketing/AdvertiseType');
const PendingAccessIndex = () => 
  import(/* webpackChunkName: 'PendingAccessIndex' */ '@/Marketing/PendingAccess');


export default [
  {
    path: '/marketing',
    name: 'marketing',
    component: MarketingIndex,
    meta: { auth: true },
  },
  {
    path: '/breakthrough',
    name: 'breakthrough',
    component: BreakthroughIndex,
    meta: { auth: true },
  },
  {
    path: '/facebook-ads-get-started',
    name: 'facebook-ads-get-started',
    component: GetStartedIndex,
    meta: { auth: true },
  },
  {
    path: '/advertising/:type',
    name: 'advertising',
    component: AdvertiseType,
    meta: { auth: true },
  },
  {
    path: '/pending-access',
    name: 'pending-access',
    component: PendingAccessIndex,
    meta: { auth: true },
  },
];
